import axios, { AxiosError } from "axios"
import { LOGIN_PATH, USER_PATH } from "../../constants/paths"
import { ILoginResponse } from "types"
import {
  requestInterceptorErrorSecurityCredentials,
  requestInterceptorSuccessCredentials,
  responseInterceptorErrorCredentials,
  responseInterceptorSuccessCredentials,
} from "interceptors"

const instance = axios.create({
  baseURL: process.env.REACT_APP_CREDENTIALS_API_SERVICE_DOMAIN,
})

instance.interceptors.request.use(
  requestInterceptorSuccessCredentials,
  requestInterceptorErrorSecurityCredentials
)

instance.interceptors.response.use(
  responseInterceptorSuccessCredentials,
  responseInterceptorErrorCredentials
)

export const loginService = async (credentials: any) => {
  try {
    const result = await instance.post(USER_PATH + LOGIN_PATH, credentials)
    return result.data as ILoginResponse
  } catch (error: any) {
    throw new Error((error as AxiosError)?.response?.data)
  }
}
